import { getStore } from "../store/store";
import { type CommandingViewMode } from "owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions";

export const isSingleLineRibbon = (): boolean => getStore().viewMode === 1;
